import _ from 'lodash';

import React, { Component } from 'react';
import { Button, Form, Header, Icon, Modal, Checkbox } from 'semantic-ui-react';

import API from '../services/api.js';

const optionsService = [
	{
		key: 'BYBIT',
		text: 'ByBIT',
		value: 'BYBIT'
	},
	{
		key: 'MEXC',
		text: 'MEXC',
		value: 'MEXC'
	},
];

class UserConfig extends Component {

	constructor (props) {
		super(props);

		this.state = {
			tid: "",
			key: "",
			secret: "",
			service: "BYBIT",
			useTestNet: true
		};

		this.closeModal = props.closeModal;
	}

	saveConfig = async () => {
		const {
			key,
			secret,
			service,
			useTestNet
		} = this.state;

		try {
			await API.Config.set({
				key,
				secret,
				service,
				useTestNet
			});
			this.closeModal();
		} catch (err) {
			console.error(err);
		}
	}

	saveTid = async () => {
		const {
			tid,
		} = this.state;

		try {
			await API.Config.setTid(tid);
			this.closeModal();
		} catch (err) {
			console.error(err);
		}
	}

	handleChange = (key, _value) => (e, { value }) => {
		this.setState({ [key]: (!_.isNil(_value) ? _value : value) });
	}

	render () {
		const { key, secret, service, useTestNet, tid } = this.state;

		return (<>
				<Header icon="archive" content="Настройки пользователя"/>
				<Modal.Content>
					<Form>
						<Form.Group widths="equal">
							<Form.Input fluid label={'API KEY:'} placeholder="" value={key} onChange={this.handleChange('key')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input fluid label={'API SECRET:'} placeholder="" value={secret} onChange={this.handleChange('secret')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Select
								fluid
								label={'Биржа'}
								options={optionsService}
								value={service}
								onChange={this.handleChange('service')}
							/>
						</Form.Group>
						<Form.Group widths="equal">
							<Checkbox toggle fluid
									  label={'Тестовый режим:'}
									  checked={useTestNet}
									  onChange={this.handleChange('useTestNet', !useTestNet)} />
						</Form.Group>
					</Form>
					<Form>
						<Form.Group widths="equal">
							<Form.Input fluid label={'TID:'} placeholder="" value={tid} onChange={this.handleChange('tid')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Button color="green" onClick={() => this.saveTid()}>
								<Icon name="checkmark"/> Сохранить TID
							</Button>
						</Form.Group>
					</Form>
				</Modal.Content>
				<Modal.Actions>
					<Button color="red" onClick={this.closeModal}>
						<Icon name="remove"/> Закрыть
					</Button>
					<Button color="green" onClick={() => this.saveConfig()}>
						<Icon name="checkmark"/> Сохранить
					</Button>
				</Modal.Actions>
			</>
		);
	}
}

export default UserConfig;
